/* iSpice spice benefits - "The spice herbarium" - 2026-10-06
   Reads each spice card's benefit list (from its article), groups it into wellness themes, then builds:
   the benefit wheel, the theme chips with counts, search, the theme dots on each card and the profile panel
   (with Add to cart through /cart/add.js, which opens the iSpice cart panel).
   Disease and weight claims (cancer, weight loss) are never shown.
   Without this script the page still shows every spice card with a link-free name and photo. */
(function () {
  'use strict';

  var THEMES = [
    { id: 'digestion', label: 'Digestion', color: '#9DB57E', match: /digest|nutrient absorption/i,
      text: 'Warming seeds, roots and herbs that cooks have long reached for after a rich meal.',
      icon: '<path d="M12 3c4 3 6 6 6 9a6 6 0 0 1-12 0c0-3 2-6 6-9z"/><path d="M12 9v9"/>' },
    { id: 'heart', label: 'Heart & circulation', color: '#D4917C', match: /heart|cholesterol|circulat/i,
      text: 'Studied for their place in a heart-friendly, balanced way of eating.',
      icon: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>' },
    { id: 'antioxidant', label: 'Antioxidant', color: '#D8B45F', match: /antioxidant|anti-?inflam|arthrit/i,
      text: 'Rich in plant compounds that help counter everyday oxidative stress and inflammation.',
      icon: '<circle cx="12" cy="12" r="3.2"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/>' },
    { id: 'antimicrobial', label: 'Natural antimicrobial', color: '#7FAAB5', match: /microb/i,
      text: 'Plant compounds that research has studied for natural antimicrobial activity.',
      icon: '<path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/>' },
    { id: 'immune', label: 'Immune support', color: '#A990BE', match: /immun/i,
      text: 'Herbs traditionally linked with supporting the body’s natural defences.',
      icon: '<circle cx="12" cy="12" r="4"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/>' },
    { id: 'brain', label: 'Brain & mood', color: '#8FA5D0', match: /brain|mood|nerve/i,
      text: 'Being explored for antioxidant support of brain health and a balanced mood.',
      icon: '<path d="M9 4a3 3 0 0 0-3 3 3 3 0 0 0-2 5 3 3 0 0 0 2 5 3 3 0 0 0 3 3V4zM15 4a3 3 0 0 1 3 3 3 3 0 0 1 2 5 3 3 0 0 1-2 5 3 3 0 0 1-3 3V4z"/>' },
    { id: 'sugar', label: 'Blood-sugar balance', color: '#DCA874', match: /blood.?sugar|glucose/i,
      text: 'Researched for their effect on normal glucose metabolism as part of a balanced diet.',
      icon: '<path d="M12 3l3 5h-6zM7 11h10l-1 9H8z"/>' },
    { id: 'beauty', label: 'Skin, hair & eyes', color: '#D69A95', match: /skin|hair|eye/i,
      text: 'Carotenoids and antioxidants associated with healthy skin, hair and eyes.',
      icon: '<path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12z"/><circle cx="12" cy="12" r="2.5"/>' },
    { id: 'minerals', label: 'Minerals', color: '#B0A57B', match: /manganese|iron|potassium|bone/i,
      text: 'A small but useful source of minerals such as manganese and iron.',
      icon: '<path d="M6 3h12l3 6-9 12L3 9z"/><path d="M3 9h18M9 3l3 18M15 3l-3 18"/>' }
  ];
  var NEVER = /cancer|weight|tumou?r|diabet|cure/i; // claims we do not make
  var byId = {};
  THEMES.forEach(function (t) { byId[t.id] = t; });

  function esc(t) { return String(t || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(t) { return String(t || '').replace(/[\s ]+/g, ' ').trim(); }
  // text from the article arrives with HTML entities still in it ("Skin &amp; Hair")
  var deco = document.createElement('textarea');
  function decode(t) { deco.innerHTML = String(t || ''); return norm(deco.value); }
  function svgIcon(t, cls) { return '<svg class="' + (cls || '') + '" viewBox="0 0 24 24" aria-hidden="true">' + t.icon + '</svg>'; }

  // "Turmeric Some research ... benefits: §Anti-inflammatory§ §Antioxidants§ ..." -> clean list
  function parseBenefits(raw) {
    var parts = String(raw || '').split('§').map(decode);
    parts.shift(); // heading text before the first item
    var seen = {}, out = [];
    parts.forEach(function (p) {
      if (!p || p.length > 60 || NEVER.test(p) || /benefits/i.test(p)) return; // headings between lists
      var k = p.toLowerCase().replace(/[^a-z]/g, '');
      if (seen[k]) return;
      seen[k] = 1;
      out.push(p.charAt(0).toUpperCase() + p.slice(1));
    });
    return out;
  }
  function themesFor(benefits, extra) {
    var ids = [];
    THEMES.forEach(function (t) { if (benefits.some(function (b) { return t.match.test(b); })) ids.push(t.id); });
    String(extra || '').split(',').map(norm).filter(Boolean).forEach(function (x) {
      var t = THEMES.filter(function (t) { return t.id === x.toLowerCase() || t.label.toLowerCase().indexOf(x.toLowerCase()) === 0; })[0];
      if (t && ids.indexOf(t.id) < 0) ids.push(t.id);
    });
    return ids;
  }

  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.isx-sb-card'));
    var data = cards.map(function (el, i) {
      var benefits = parseBenefits(el.dataset.benefits);
      var themes = themesFor(benefits, el.dataset.extra);
      var img = el.querySelector('.is-main');
      return { el: el, i: i, name: el.dataset.name, latin: el.dataset.latin, benefits: benefits, themes: themes,
        intro: decode(el.dataset.intro), source: decode(el.dataset.source), article: el.dataset.article, img: img ? (img.currentSrc || img.src) : '',
        product: el.dataset.productUrl ? { url: el.dataset.productUrl, title: el.dataset.productTitle, price: el.dataset.productPrice,
          variant: el.dataset.productVariant, img: el.dataset.productImg } : null };
    });

    // theme dots on each card
    data.forEach(function (d) {
      var box = d.el.querySelector('[data-isx-sb-dots]');
      d.el.dataset.themes = d.themes.join(' ');
      if (!box) return;
      if (!d.themes.length) { box.innerHTML = '<span class="is-culinary">Culinary profile</span>'; return; }
      box.innerHTML = d.themes.slice(0, 4).map(function (id) {
        return '<i style="--c:' + byId[id].color + '" title="' + esc(byId[id].label) + '"></i>';
      }).join('') + '<span>' + d.themes.length + (d.themes.length === 1 ? ' theme' : ' themes') + '</span>';
    });

    // theme counts; themes no spice belongs to are left out
    var counts = {};
    data.forEach(function (d) { d.themes.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; }); });
    var live = THEMES.filter(function (t) { return counts[t.id]; });
    var countEl = root.querySelector('[data-isx-sb-themecount]');
    if (countEl) countEl.textContent = live.length;

    // chips
    var chipsBox = root.querySelector('.isx-sb-chips');
    live.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'isx-sb-chip'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', 'false');
      b.dataset.theme = t.id; b.style.setProperty('--c', t.color);
      b.innerHTML = svgIcon(t) + esc(t.label) + ' <b>' + counts[t.id] + '</b>';
      chipsBox.appendChild(b);
    });

    // wheel, background and the body
    buildWheel(root, live, counts);
    buildBackground(root);
    var shape = bodyPath();
    root.querySelectorAll('[data-isx-sb-shape]').forEach(function (p) { p.setAttribute('d', shape); });
    var spots = Array.prototype.slice.call(root.querySelectorAll('.isx-sb-spot'));
    spots.forEach(function (g, i) {
      var t = byId[g.dataset.theme];
      if (!t || !counts[t.id]) { g.remove(); return; }
      g.style.setProperty('--c', t.color);
      g.style.setProperty('--d', (i * 0.31).toFixed(2) + 's');
      g.setAttribute('tabindex', '0'); g.setAttribute('role', 'button');
      g.setAttribute('aria-label', t.label + ', ' + counts[t.id] + ' spices');
      var title = document.createElementNS('http://www.w3.org/2000/svg', 'title'); title.textContent = t.label; g.appendChild(title);
    });
    var capLabel = root.querySelector('[data-isx-sb-cap-label]'), capText = root.querySelector('[data-isx-sb-cap-text]');
    var cap0 = capLabel ? [capLabel.textContent, capText.textContent] : null;
    function light(id) { // highlight one theme on the ring and the body, with a caption
      root.querySelectorAll('.isx-sb-seg, .isx-sb-spot').forEach(function (g) { g.classList.toggle('is-lit', !!id && g.dataset.theme === id); });
      if (!capLabel) return;
      if (id && byId[id]) { capLabel.textContent = byId[id].label; capText.textContent = counts[id] + ' spices · ' + byId[id].text; }
      else { capLabel.textContent = cap0[0]; capText.textContent = cap0[1]; }
    }
    // a slow tour of the themes while the banner is on screen
    var tour = { i: 0, timer: null, hover: false, seen: false };
    var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function tick() {
      if (tour.hover || state.theme !== 'all' || !tour.seen) return;
      light(live[tour.i % live.length].id); tour.i++;
    }
    if (!still && live.length) {
      var heroBox = root.querySelector('.isx-sb-hero').getBoundingClientRect();
      tour.seen = heroBox.top < innerHeight && heroBox.bottom > 0;
      tour.timer = setInterval(tick, 3200);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { tour.seen = es[0].isIntersecting; }, { threshold: 0.3 }).observe(root.querySelector('.isx-sb-hero'));
      } else { tour.seen = true; }
    }
    var visual = root.querySelector('.isx-sb-visual');
    if (visual) {
      visual.addEventListener('mouseover', function (e) {
        var g = e.target.closest('.isx-sb-seg, .isx-sb-spot');
        if (!g) return;
        tour.hover = true; light(g.dataset.theme);
      });
      visual.addEventListener('mouseleave', function () { tour.hover = false; light(state.theme !== 'all' ? state.theme : null); });
      visual.addEventListener('keydown', function (e) {
        var g = e.target.closest('.isx-sb-seg, .isx-sb-spot');
        if (g && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); g.dispatchEvent(new MouseEvent('click', { bubbles: true })); }
      });
      visual.addEventListener('focusin', function (e) { var g = e.target.closest('.isx-sb-seg, .isx-sb-spot'); if (g) { tour.hover = true; light(g.dataset.theme); } });
      visual.addEventListener('focusout', function () { tour.hover = false; });
    }

    // filtering
    var info = root.querySelector('[data-isx-sb-info]');
    var allText = info ? info.textContent : '';
    var find = root.querySelector('[data-isx-sb-find]');
    var empty = root.querySelector('[data-isx-sb-empty]');
    var state = { theme: 'all', q: '' };
    function visible() {
      return data.filter(function (d) {
        var okT = state.theme === 'all' || d.themes.indexOf(state.theme) > -1;
        var q = state.q.toLowerCase();
        var okQ = !q || d.name.toLowerCase().indexOf(q) > -1 || (d.latin || '').toLowerCase().indexOf(q) > -1;
        return okT && okQ;
      });
    }
    function apply(scroll) {
      var show = visible();
      // FLIP: remember positions, toggle, then animate from the old spot
      var first = {};
      data.forEach(function (d) { if (!d.el.hidden) first[d.i] = d.el.getBoundingClientRect(); });
      data.forEach(function (d) { d.el.hidden = show.indexOf(d) < 0; });
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        show.forEach(function (d) {
          var a = first[d.i], b = d.el.getBoundingClientRect();
          if (a) {
            d.el.animate([{ transform: 'translate(' + (a.left - b.left) + 'px,' + (a.top - b.top) + 'px)' }, { transform: 'none' }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
          } else {
            d.el.animate([{ opacity: 0, transform: 'translateY(10px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 360, easing: 'ease-out' });
          }
        });
      }
      Array.prototype.forEach.call(chipsBox.children, function (c) {
        var on = c.dataset.theme === state.theme;
        c.classList.toggle('is-on', on); c.setAttribute('aria-selected', String(on));
      });
      root.querySelectorAll('.isx-sb-seg, .isx-sb-spot').forEach(function (s) { s.classList.toggle('is-on', s.dataset.theme === state.theme); });
      if (typeof light === 'function') light(state.theme !== 'all' ? state.theme : null);
      if (info) {
        var t = byId[state.theme];
        info.innerHTML = t ? '<b style="--c:' + t.color + '">' + esc(t.label) + '</b> ' + esc(t.text) + ' <span>' + show.length + ' spices</span>' : esc(allText);
      }
      if (empty) empty.hidden = show.length > 0;
      if (scroll) root.querySelector('#isx-sb-explore').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.isx-sb-chip, .isx-sb-seg, .isx-sb-spot');
      if (chip) { state.theme = chip.dataset.theme === state.theme && chip.dataset.theme !== 'all' ? 'all' : chip.dataset.theme; apply(!chip.classList.contains('isx-sb-chip')); }
      if (e.target.closest('[data-isx-sb-reset]')) { state = { theme: 'all', q: '' }; if (find) find.value = ''; apply(); }
    });
    if (find) find.addEventListener('input', function () { state.q = norm(find.value); apply(); });

    // profile panel
    var panel = root.querySelector('[data-isx-sb-panel]');
    var scrim = root.querySelector('[data-isx-sb-scrim]');
    // move the panel to <body> so no theme wrapper (transform / overflow) can trap a fixed element
    var portal = document.createElement('div');
    portal.className = 'isx-sb isx-sb-portal';
    portal.appendChild(scrim); portal.appendChild(panel);
    document.body.appendChild(portal);
    var current = null, opener = null;
    function q(k) { return panel.querySelector('[data-p="' + k + '"]'); }
    function fill(d) {
      current = d;
      q('no').textContent = d.el.querySelector('.isx-sb-card__no').textContent;
      q('img').innerHTML = d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.name) + '">' : '';
      q('name').textContent = d.name;
      q('latin').textContent = d.latin || '';
      q('themes').innerHTML = d.themes.map(function (id) {
        var t = byId[id];
        return '<span style="--c:' + t.color + '">' + svgIcon(t) + esc(t.label) + '</span>';
      }).join('');
      q('benefits').innerHTML = d.benefits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('');
      q('benefits-wrap').hidden = !d.benefits.length;
      q('intro').textContent = d.intro || '';
      q('intro-wrap').hidden = !d.intro;
      var buy = q('buy');
      if (d.product) {
        buy.hidden = false;
        buy.innerHTML = '<a class="isx-sb-buy__img" href="' + esc(d.product.url) + '">' + (d.product.img ? '<img src="' + esc(d.product.img) + '" alt="">' : '') + '</a>' +
          '<div class="isx-sb-buy__txt"><a href="' + esc(d.product.url) + '">' + esc(shortTitle(d.product.title)) + '</a><span>' + esc(d.product.price) + '</span></div>' +
          (d.product.variant ? '<button type="button" class="isx-sb-btn is-small" data-isx-sb-add="' + esc(d.product.variant) + '">Add to cart</button>'
                             : '<a class="isx-sb-btn is-small is-ghost" href="' + esc(d.product.url) + '">Choose size</a>');
      } else { buy.hidden = true; buy.innerHTML = ''; }
      var src = q('src');
      src.hidden = !d.source;
      src.innerHTML = d.source ? 'Source: ' + sourceHtml(d.source) : '';
      var art = q('article');
      art.hidden = !d.article;
      if (d.article) art.href = d.article;
      panel.querySelector('.isx-sb-panel__scroll').scrollTop = 0;
      try { history.replaceState(null, '', '#' + d.el.id); } catch (e) {}
    }
    // a citation may be a bare link, or text with links in it
    function sourceHtml(t) {
      return esc(t).replace(/https?:\/\/[^\s<]+[^\s<.,;)]/g, function (u) {
        var label = u.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
        if (label.length > 48) label = label.slice(0, 45) + '…';
        return '<a href="' + u + '" target="_blank" rel="noopener nofollow">' + label + '</a>';
      });
    }
    function shortTitle(t) {
      var parts = String(t || '').split('|').map(norm).filter(Boolean);
      if (parts.length > 1 && /^ispice( blend)?$|^szeged$|^spice$/i.test(parts[0])) parts.shift();
      return parts.slice(0, 2).join(' · ');
    }
    function open(d, from) {
      opener = from || null;
      fill(d);
      scrim.hidden = false; panel.hidden = false;
      void panel.offsetWidth; // apply the off-screen position first so the slide-in animates
      scrim.classList.add('is-on'); panel.classList.add('is-on');
      document.documentElement.classList.add('isx-sb-lock');
      panel.querySelector('[data-isx-sb-close]').focus({ preventScroll: true });
    }
    function close() {
      panel.classList.remove('is-on'); scrim.classList.remove('is-on');
      document.documentElement.classList.remove('isx-sb-lock');
      setTimeout(function () { panel.hidden = true; scrim.hidden = true; }, 320);
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      if (opener) opener.focus({ preventScroll: true });
      current = null;
    }
    function step(dir) {
      var list = visible();
      if (!current || !list.length) return;
      var i = list.indexOf(current);
      fill(list[(i + dir + list.length) % list.length]);
    }
    data.forEach(function (d) {
      d.el.querySelector('.isx-sb-card__open').addEventListener('click', function (e) { open(d, e.currentTarget); });
    });
    scrim.addEventListener('click', close);
    panel.querySelector('[data-isx-sb-close]').addEventListener('click', close);
    panel.querySelector('[data-isx-sb-prev]').addEventListener('click', function () { step(-1); });
    panel.querySelector('[data-isx-sb-next]').addEventListener('click', function () { step(1); });
    document.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'Tab') { // keep focus inside the panel
        var f = panel.querySelectorAll('button:not([hidden]), a[href]:not([hidden])');
        f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-isx-sb-add]');
      if (!b) return;
      var label = b.textContent;
      b.disabled = true; b.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(b.dataset.isxSbAdd), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () { b.textContent = 'Added'; close(); setTimeout(function () { b.textContent = label; b.disabled = false; }, 1200); })
        .catch(function (err) { console.warn('ispice-benefits add to cart', err); location.href = current && current.product ? current.product.url : '/cart'; });
    });
    // swipe down to close on phones
    var y0 = null;
    panel.addEventListener('touchstart', function (e) { y0 = panel.querySelector('.isx-sb-panel__scroll').scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
    panel.addEventListener('touchend', function (e) { if (y0 !== null && e.changedTouches[0].clientY - y0 > 90 && innerWidth < 768) close(); y0 = null; });

    // deep link: /pages/...#spice-turmeric
    var hash = decodeURIComponent(location.hash.slice(1));
    var target = hash && data.filter(function (d) { return d.el.id === hash; })[0];
    if (target) setTimeout(function () { open(target); }, 300);

    apply();
    root.classList.add('is-ready');
  }

  function buildWheel(root, live, counts) {
    var svg = root.querySelector('.isx-sb-wheel__svg');
    if (!svg || !live.length) return;
    var cx = 200, cy = 200, r1 = 152, r2 = 190, n = live.length, gap = 0.03, html = '';
    function pt(r, a) { return [cx + r * Math.cos(a), cy + r * Math.sin(a)]; }
    live.forEach(function (t, i) {
      var a0 = -Math.PI / 2 + (i / n) * Math.PI * 2 + gap, a1 = -Math.PI / 2 + ((i + 1) / n) * Math.PI * 2 - gap;
      var p1 = pt(r2, a0), p2 = pt(r2, a1), p3 = pt(r1, a1), p4 = pt(r1, a0), big = a1 - a0 > Math.PI ? 1 : 0;
      var d = 'M' + p1 + ' A' + r2 + ' ' + r2 + ' 0 ' + big + ' 1 ' + p2 + ' L' + p3 + ' A' + r1 + ' ' + r1 + ' 0 ' + big + ' 0 ' + p4 + 'Z';
      var ic = pt((r1 + r2) / 2, (a0 + a1) / 2);
      html += '<g class="isx-sb-seg" data-theme="' + t.id + '" style="--c:' + t.color + ';--d:' + (i * 70) + 'ms" tabindex="0" role="button" aria-label="' + esc(t.label) + ', ' + counts[t.id] + ' spices">' +
        '<path d="' + d.replace(/,/g, ' ') + '"/>' +
        '<g transform="translate(' + (ic[0] - 13) + ' ' + (ic[1] - 13) + ') scale(1.08)"><g class="isx-sb-seg__icon">' + t.icon + '</g></g>' +
        '<title>' + esc(t.label) + '</title></g>';
    });
    svg.innerHTML = html;
  }

  // body outline: right half of a standing figure (viewBox 0 0 200 400), mirrored, joined by a smooth curve
  var BODY = [[108,70],[122,76],[140,84],[150,96],[155,122],[159,156],[164,190],[169,226],[173,252],[178,272],[172,283],[165,268],[159,234],[152,196],[145,156],[138,128],[133,152],[127,188],[134,228],[135,262],[132,296],[128,330],[126,362],[122,388],[132,398],[108,398],[108,384],[110,352],[108,320],[105,286],[100,256]];
  function bodyPath() {
    var p = BODY.concat(BODY.slice(0, -1).reverse().map(function (q) { return [200 - q[0], q[1]]; }));
    var n = p.length, d = 'M' + p[0][0] + ' ' + p[0][1];
    for (var i = 0; i < n; i++) {
      var p0 = p[(i - 1 + n) % n], p1 = p[i], p2 = p[(i + 1) % n], p3 = p[(i + 2) % n];
      d += ' C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) + ' ' +
        (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) + ' ' + p2[0] + ' ' + p2[1];
    }
    return d + 'Z';
  }

  // medical layer behind the banner, in the same soft-3D style as the rest of the site:
  // a DNA helix scrolling along the top, a heartbeat trace along the bottom, raised capsules,
  // cells, molecules and a medical cross floating at the edges (the middle stays clear for the text and wheel)
  var MED = [ // kind, x%, y%, size px, rotate deg, theme colour; pieces at the edge are partly cropped by the banner, which gives depth
    ['pill', 5, 12, 72, -24, 'heart'], ['pill', 47, 9, 56, 30, 'digestion'], ['pill', 97, 30, 70, 70, 'brain'],
    ['pill', 44, 91, 60, -30, 'antioxidant'], ['pill', 90, 92, 64, 18, 'immune'],
    ['cell', 1.5, 62, 64, 0, 'antimicrobial'], ['cell', 52, 79, 46, 0, 'beauty'], ['cell', 98, 8, 56, 0, 'sugar'],
    ['mol', 26, 92, 80, 10, ''], ['mol', 62, 7, 84, -20, ''], ['mol', 99, 68, 90, 30, ''],
    ['plus', 52.5, 52, 40, 0, ''], ['plus', 12, 91, 38, 0, '']
  ];
  var MOL = '<g class="isx-sb-mol__b"><path d="M30 12l15.6 9v18L30 48l-15.6-9V21z"/><path d="M45.6 21L58 14M30 48v12M14.4 21L4 14"/></g>' +
    '<g class="isx-sb-mol__n"><circle cx="30" cy="12" r="3.4"/><circle cx="45.6" cy="21" r="3.4"/><circle cx="45.6" cy="39" r="3.4"/><circle cx="30" cy="48" r="3.4"/>' +
    '<circle cx="14.4" cy="39" r="3.4"/><circle cx="14.4" cy="21" r="3.4"/><circle cx="58" cy="14" r="4.6"/><circle cx="30" cy="60" r="4.6"/><circle cx="4" cy="14" r="4.6"/></g>';
  function helix() { // two periods of a double helix; the strip slides by one period, so the loop is seamless
    var a = '', b = '', rungs = '', w = 1200, h = 44, amp = 15, per = 150;
    for (var x = 0; x <= w * 2; x += 6) {
      var t = x / per * Math.PI * 2, y1 = h / 2 + amp * Math.sin(t), y2 = h / 2 - amp * Math.sin(t);
      a += (x ? 'L' : 'M') + x + ' ' + y1.toFixed(1); b += (x ? 'L' : 'M') + x + ' ' + y2.toFixed(1);
      if (x % 18 === 0) rungs += 'M' + x + ' ' + y1.toFixed(1) + 'L' + x + ' ' + y2.toFixed(1);
    }
    return '<svg class="isx-sb-dna" viewBox="0 0 2400 44" preserveAspectRatio="xMinYMid slice" aria-hidden="true"><path class="isx-sb-dna__rung" d="' + rungs + '"/>' +
      '<path class="isx-sb-dna__a" d="' + a + '"/><path class="isx-sb-dna__b" d="' + b + '"/></svg>';
  }
  function ecg() { // flat line with a heartbeat every 300 units
    var d = 'M0 30', x = 0;
    while (x < 1200) { d += ' L' + (x + 160) + ' 30 L' + (x + 172) + ' 24 L' + (x + 184) + ' 30 L' + (x + 196) + ' 30 L' + (x + 204) + ' 38 L' + (x + 216) + ' 4 L' + (x + 228) + ' 50 L' + (x + 238) + ' 30 L' + (x + 256) + ' 30 L' + (x + 272) + ' 22 L' + (x + 290) + ' 30 L' + (x + 300) + ' 30'; x += 300; }
    return '<svg class="isx-sb-ecg" viewBox="0 0 1200 54" preserveAspectRatio="none" aria-hidden="true"><path class="isx-sb-ecg__base" d="' + d + '"/><path class="isx-sb-ecg__pulse" pathLength="1000" d="' + d + '"/></svg>';
  }
  function buildBackground(root) {
    var bg = root.querySelector('[data-isx-sb-bg]');
    if (!bg) return;
    bg.innerHTML = helix() + ecg() + MED.map(function (m, i) {
      var st = 'left:' + m[1] + '%;top:' + m[2] + '%;--s:' + m[3] + 'px;--r:' + m[4] + 'deg;--t:' + (11 + (i % 4) * 3) + 's;--d:-' + (i * 1.9).toFixed(1) + 's' +
        (m[5] ? ';--c:' + byId[m[5]].color : '');
      if (m[0] === 'mol') return '<svg class="isx-sb-med isx-sb-mol" viewBox="-2 6 66 60" style="' + st + '">' + MOL + '</svg>';
      return '<i class="isx-sb-med isx-sb-' + m[0] + '" style="' + st + '"></i>';
    }).join('');
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-isx-sb]'), function (root) {
      if (root.dataset.isxDone) return;
      root.dataset.isxDone = '1';
      try { init(root); } catch (e) { console.warn('ispice-benefits', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
